import type {
  OrganizationUserDto,
  Pagination,
  UserType,
} from "@superblocksteam/shared";

import { reduxApiSlice, UsersTag } from "./index";

const extendedApi = reduxApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    listUsers: builder.query<
      OrganizationUserDto[],
      { organizationId: string; type?: UserType }
    >({
      query: ({ organizationId, type }) =>
        `v1/organizations/${organizationId}/users${
          type ? `?${new URLSearchParams({ type }).toString()}` : ""
        }`,
      transformResponse: (response: { data: OrganizationUserDto[] }) =>
        response.data,
      providesTags: [UsersTag],
    }),
    listUsersPage: builder.query<
      Pagination<OrganizationUserDto>,
      {
        organizationId: string;
        type?: UserType;
        limit: number;
        offset: number;
        search?: string;
        status?: string;
        roleId?: string;
        sort?: string;
        direction?: "asc" | "desc";
      }
    >({
      query: ({
        organizationId,
        type,
        limit,
        offset,
        search,
        status,
        roleId,
        sort,
        direction,
      }) => {
        const params = new URLSearchParams({
          limit: String(limit),
          offset: String(offset),
        });
        if (type) params.set("type", type);
        if (search) params.set("search", search);
        if (status !== undefined) params.set("status", status);
        if (roleId !== undefined) params.set("roleId", roleId);
        if (sort) params.set("sort", sort);
        if (direction) params.set("direction", direction);
        return `v1/organizations/${organizationId}/users?${params.toString()}`;
      },
      transformResponse: (response: {
        data: Pagination<OrganizationUserDto>;
      }) => response.data,
      providesTags: [{ type: UsersTag, id: "PAGE" }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useListUsersQuery,
  useLazyListUsersQuery,
  useLazyListUsersPageQuery,
} = extendedApi;

export const listUsersPage = extendedApi.endpoints.listUsersPage;
